export const ICONS = Object.freeze({
  add: 'add',
  cancel: 'cancel',
  close: 'close',
  copy: 'content_copy',
  danger: 'error',
  delete: 'delete',
  download: 'arrow_circle_down',
  drop_down: 'arrow_drop_down',
  edit: 'edit',
  error: 'sentiment_dissatisfied',
  extension: 'extension',
  history: 'history',
  home: 'home',
  info: 'info',
  manual: 'build',
  marketplace: 'storefront',
  move_down: 'keyboard_double_arrow_down',
  move_up: 'keyboard_double_arrow_up',
  new: 'add',
  new_pack: 'box_add',
  new_prompt: 'chat_add_on',
  no: 'close',
  organization: 'work',
  pack: 'box',
  people: 'group',
  preview: 'preview',
  preview_off: 'preview_off',
  private: 'lock',
  prompt: 'chat',
  public: 'public',
  references: 'family_history',
  save: 'check_circle',
  search: 'search',
  settings: 'settings',
  show_all: 'chevron_right',
  terminal: 'terminal',
  unknown: 'help',
  usage: 'wand_stars',
  user: 'person',
  warning: 'warning',
  yes: 'check',
})

export type IconType = keyof typeof ICONS;

export function iconAttribute(value: unknown): IconType {
  if (typeof value === 'string' && value in ICONS) {
    return value as IconType;
  }
  console.error(`Unknown icon type: ${value}`)
  console.trace()
  return 'unknown'
}

export function iconResolver(value: string): string {
  if (value in ICONS) return (ICONS as any)[value]

  console.error(`Unknown icon type: ${value}`)
  console.trace()
  return ICONS.unknown
}
